import { onCtxAbort, reaction } from '@reatom/framework'

import { delugeIdAtom } from '@root/entities/auth'
import { selectedNetworkAtom } from '@root/entities/network'
import { dependenciesAtom } from '@root/features/shared/dependencies'

import { trackingWalletAlertsTableModel } from './reatom-tracking-wallets-alerts-table'

export const initializeTrackingWalletsAlertsReaction = reaction((ctx) => {
  const delugeId = ctx.spy(delugeIdAtom)
  if (!delugeId) {
    return
  }
  const network = ctx.spy(selectedNetworkAtom)

  /**
   * Held for the life of the app, not read when somebody looks.
   *
   * Subscribing is what keeps the rows: a table nobody holds loses its state,
   * so opening the footer panel used to start the read again and show a
   * spinner over a list that had already been fetched once — measured on the
   * deployed staging, `get-alerts` ran at 1.4s for the background load and
   * again at 14s the moment the panel opened. Now the panel shows what is
   * there, and the socket keeps it current.
   */
  const stopHoldingTheList = ctx.subscribe(
    trackingWalletAlertsTableModel,
    () => {},
  )
  const { mainWebsocket } = ctx.get(dependenciesAtom)
  mainWebsocket.trackingWalletAlertSubscribeAction(ctx, {
    delugeId,
    network,
  })

  /**
   * A reconnect restores the flow but not what was missed while it was down.
   *
   * Re-subscribing is handled for every channel at once, and it brings back
   * the trades from the moment the socket returns — the ones that happened
   * in between are simply gone. The list is what the panel shows, so it is
   * read again rather than left with a hole in it.
   */
  const stopWatchingReconnects = ctx.subscribe(
    mainWebsocket.reconnectedAction,
    (calls) => {
      if (calls.length > 0) {
        trackingWalletAlertsTableModel.load(ctx)
      }
    },
  )

  onCtxAbort(ctx, () => {
    stopHoldingTheList()
    stopWatchingReconnects()
    mainWebsocket.trackingWalletAlertUnsubscribeAction(ctx, {
      network,
      delugeId,
    })
  })
}, 'initializeTrackingWalletsAlertsReaction')
